"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const complex_plugin_1 = require("complex-plugin");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const overdue_1 = __importDefault(require("@/pages/index/api/overdue"));
const dictionary_1 = require("@/config/dictionary");
const overdue_2 = require("@/pages/index/select/overdue");
const MessageTemplate_vue_1 = __importDefault(require("./MessageTemplate.vue"));
const contractNumber = new complex_data_1.SelectList({
    list: []
});
const addPhoneStr = '{{专员联系电话}}';
exports.default = (0, vue_1.defineComponent)({
    name: 'BuildMessage',
    components: {
        ListView: ListView_1.default
    },
    data() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        class ContactsList extends complex_data_1.ComplexList {
            buildItem(postData) {
                return new Promise((resolve, reject) => {
                    complex_plugin_1.notice.confirm('确认进行短信通知吗？', '警告', (act) => {
                        if (act === 'ok') {
                            const recipientPhone = postData.recipientPhone;
                            postData.recipientName = contractNumber.getItem(recipientPhone).name;
                            if (postData.smsContent.includes(addPhoneStr)) {
                                postData.smsContent = postData.smsContent.replace(addPhoneStr, postData.addPhone);
                            }
                            overdue_1.default.pushMessage.require(postData).then(() => {
                                complex_plugin_1.notice.showMsg('短信发送成功！', 'success');
                                self.$emit('send');
                                resolve({ status: 'success' });
                            }).catch(err => {
                                // eslint-disable-next-line no-console
                                console.error(err);
                                reject(err);
                            });
                        }
                        else {
                            reject({ status: 'fail' });
                        }
                    });
                });
            }
        }
        const mainData = new ContactsList({
            name: '短信通知',
            prop: 'contactsList',
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 24,
                            label: 8,
                            content: 16
                        }
                    },
                    option: {},
                    propData: {
                        id: 'id'
                    },
                    list: [
                        {
                            prop: 'id',
                            name: 'ID',
                            originProp: 'id',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'businessId',
                            name: '业务ID',
                            originProp: 'businessId',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    type: 'input',
                                    disabled: true,
                                    observe(target) {
                                        target.hidden('businessId');
                                    },
                                },
                                build: {
                                    $target: 'edit'
                                }
                            }
                        },
                        {
                            prop: 'contractNumber',
                            name: '合同编号',
                            originProp: 'contractNumber',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    type: 'input',
                                    disabled: true
                                },
                                build: {
                                    $target: 'edit'
                                }
                            }
                        },
                        {
                            prop: 'customerName',
                            name: '客户名称',
                            originProp: 'customerName',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    type: 'input',
                                    disabled: true
                                },
                                build: {
                                    $target: 'edit'
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(contractNumber, {
                            prop: 'recipientPhone',
                            name: '联系电话',
                            originProp: 'recipientPhone',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    required: true,
                                    $getData() {
                                        this.$option.list = contractNumber.getList();
                                        return Promise.resolve({ status: 'success' });
                                    }
                                },
                                build: {
                                    $target: 'edit'
                                },
                                detail: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'addPhone',
                            name: '专员联系电话',
                            originProp: 'addPhone',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    type: 'input',
                                    required: true,
                                    option: {
                                        maxLength: 13
                                    },
                                    observe(target, prop, val, from) {
                                        if (from === 'init' && prop === this.prop) {
                                            target.hidden(this.prop);
                                        }
                                    },
                                    disabled: false
                                },
                                build: {
                                    $target: 'edit'
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(overdue_2.messageTemplate, {
                            prop: 'smsContent',
                            name: '短信内容',
                            originProp: 'smsContent',
                            originFrom: 'list',
                            mod: {
                                edit: {
                                    required: true,
                                    $getData() {
                                        const record = mainData.$getExtra('parent');
                                        const regex = /{(.*?)}/g;
                                        // 替换函数，用于动态替换匹配到的变量名
                                        function replacer(_match, key) {
                                            return key !== 'addPhone' ? (record[key] || '') : addPhoneStr;
                                        }
                                        // 使用replace方法和替换函数来替换模板中的变量
                                        const list = overdue_2.messageTemplate.getList();
                                        this.$option.list = list.map(item => {
                                            const template = item.label;
                                            const content = template.replace(regex, replacer);
                                            let extraProp = '';
                                            if (content.includes(addPhoneStr)) {
                                                extraProp = 'addPhone';
                                            }
                                            return {
                                                value: content,
                                                label: content,
                                                extra: extraProp
                                            };
                                        });
                                        return Promise.resolve({ status: 'success' });
                                    },
                                    slot: {
                                        type: 'data',
                                        render(payload) {
                                            return (0, vue_1.h)(MessageTemplate_vue_1.default, {
                                                value: payload.form.data.smsContent,
                                                options: payload.data.$option.list,
                                                placeholder: payload.data.placeholder.getData(),
                                                onSelect(value, valueItem) {
                                                    payload.form.data.smsContent = value;
                                                    if (valueItem.extra) {
                                                        payload.list.show('addPhone');
                                                        payload.form.data.addPhone = undefined;
                                                    }
                                                    else {
                                                        payload.form.data.addPhone = undefined;
                                                        payload.list.hidden('addPhone');
                                                    }
                                                }
                                            });
                                        },
                                    }
                                },
                                build: {
                                    $target: 'edit'
                                },
                                detail: {
                                    $target: 'edit'
                                }
                            }
                        })
                    ]
                }
            },
            $getData() {
                return new Promise((resolve, reject) => {
                    overdue_1.default.overdueContactsList.require({
                        overdueRecordId: this.$getExtra('overdueRecordId')
                    }).then(res => {
                        this.$formatList(res.data.data, res.data.totalCount);
                        resolve({ status: 'success' });
                    }).catch(err => {
                        // eslint-disable-next-line no-console
                        console.error(err);
                        reject(err);
                    });
                });
            }
        });
        return {
            contractNumber,
            mainData: mainData,
            listOption: {
                search: false,
                edit: {
                    form: {
                        observe: true
                    }
                }
            }
        };
    },
    methods: {
        loadContract(id) {
            return new Promise((resolve, reject) => {
                overdue_1.default.overdueAllContactsList.require({
                    overdueRecordId: id
                }).then(res => {
                    const list = res.data.data.map((item) => {
                        return {
                            value: item.contactPhone,
                            label: item.contactTypeName + '/' + item.contactName + '/' + item.contactPhone,
                            name: item.contactName
                        };
                    });
                    this.contractNumber.setList(list);
                    resolve({ status: 'success' });
                }).catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    reject(err);
                });
            });
        },
        onBuild(record) {
            this.mainData.$setExtra('parent', record);
            overdue_2.messageTemplate.$loadData().finally(() => {
                this.loadContract(record.id).finally(() => {
                    this.$refs['list-view'].openEdit('build', '', {
                        businessId: record.id,
                        contractNumber: record.contractNumber,
                        customerName: record.customerName
                    });
                });
            });
        }
    }
});
